import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext.jsx';

// roles: array of allowed role strings; empty/omitted = any authenticated user
export default function ProtectedRoute({ roles = [] }) {
  const { isAuthenticated, hasRole } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (roles.length > 0 && !hasRole(...roles)) return <Navigate to="/forbidden" replace />;
  return <Outlet />;
}
